import React from 'react'

const LoadedValuesContext = React.createContext();

export default LoadedValuesContext